import "../scss/customProductSelect.scss"
import Select, { components } from "react-select";
import { useEffect, useRef, useState } from "react";
import { prakrithi, samriddhi, sukrithi } from "../consts";

const CustomControl = ({ children, ...props }) => {
  const inputWrapperRef = useRef(null);

  useEffect(() => {
    if (props.selectProps.menuIsOpen && inputWrapperRef.current) {
      const input = inputWrapperRef.current.querySelector("input");
      if (input) input.focus(); 
    }
  }, [props.selectProps.menuIsOpen]);

  return (
    <components.Control
      {...props}
      innerRef={props.innerRef}
      innerProps={{
        ...props.innerProps,
        onMouseDown: (e) => {
          e.stopPropagation();
          e.preventDefault();
          props.selectProps.setMenuIsOpen(!props.selectProps.menuIsOpen);
        },
      }}
    >
      <div ref={inputWrapperRef} className="w-100 d-flex align-items-center">
        {children}
      </div>
    </components.Control>
  );
};

const CustomProductSelect = ({ productNames, handleProductChange, selectedProducts }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const multiSelectProductIds = [prakrithi, sukrithi, samriddhi];
    const isMultiSelectMode = selectedProducts.some((p) => multiSelectProductIds.includes(p.value)); 
    const selectRef = useRef(null);

    const customOptions = productNames.map((option) => ({
        ...option,
        isDisabled: isMultiSelectMode && !multiSelectProductIds.includes(option.value),
    }));

    const formatOptionLabel = ({ label, value }, { context }) => {
        const showCheckbox = multiSelectProductIds.includes(value);
        return (
            <div className="d-flex align-items-center">
                {showCheckbox && context === "menu" && (
                    <input
                        type="checkbox"
                        checked={selectedProducts.some((p) => p.value === value)}
                        readOnly
                        className="me-2"
                    />
                )}
                <span>{label}</span>
            </div>
        );
    };

    const handleChange = (selected) => {
        if(handleProductChange) {
            handleProductChange(selected);      
        }
        const selectedArray = Array.isArray(selected) ? selected : selected ? [selected] : [];
        const lastSelected = selectedArray[selectedArray.length - 1];
        if(multiSelectProductIds.includes(lastSelected?.value)) {
            setMenuIsOpen(true)
            return
        } else {
            const input = selectRef.current?.querySelector('input');
            input?.blur();
        }
        setMenuIsOpen(false)
        
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setMenuIsOpen(false);
                const input = selectRef.current.querySelector('input');
                if (input) input.blur();

            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        if (menuIsOpen && selectRef.current) {
            selectRef.current.focus();
        }
    }, [menuIsOpen]);

    return (
        <div ref={selectRef}>
            <Select
                value={selectedProducts}
                options={customOptions}
                isMulti={isMultiSelectMode}
                onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue;
                }}
                classNamePrefix="bg-gray"
                className="fixed-height-select"
                placeholder="Select Kshema Product"
                onChange={(selected) => {handleChange(selected)}}
                formatOptionLabel={formatOptionLabel}
                isClearable={true}
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
                menuIsOpen={menuIsOpen}
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={() => setMenuIsOpen(false)}
                components={{
                    Control: CustomControl,
                    ValueContainer: ({ children, ...props }) => {
                        const selected = props.getValue() || [];
                        const displayText = selected.length > 0 ? `${selected.length} selected` : "";
                        const selectedLabels = selected.map((option) => option.label).join(', ');

                        if (selected.length === 0) {
                            return (
                                <components.ValueContainer {...props}>
                                    {children}
                                </components.ValueContainer>
                            );
                        }

                        return selected.length > 1 ? (
                            <components.ValueContainer {...props}>
                                <span className="selected-count-text">{displayText}</span>
                            </components.ValueContainer>
                        ) : (
                            <components.ValueContainer {...props}>
                                <div className="selected-labels-text">{selectedLabels}</div>
                            </components.ValueContainer>
                        );
                    },
                    MultiValue: () => null,
                }}
                setMenuIsOpen={setMenuIsOpen}
            />
        </div>
    )


}
export default CustomProductSelect